export default __webpack_public_path__ + "static/media/arrow_right-white.7c480222.svg";